import SectionWave from '../components/SectionWave';
import SEO from '../components/SEO';
import './PageShared.css';

const vaerdier = [
  { icon: '❤️', title: 'Tryghed',     desc: 'Et sikkert og trygt miljø for børn og familier i alle livsfaser.' },
  { icon: '🌈', title: 'Inklusion',   desc: 'Alle er velkomne - gravide, babyer, børn og deres forældre.' },
  { icon: '✨', title: 'Glæde',       desc: 'Vi skaber rammer for ægte, ubesværet leg og glæde.' },
  { icon: '🤝', title: 'Fællesskab', desc: 'Et mødested for familier - til de sjove stunder og de dybe samtaler.' },
];

export default function OmOs() {
  return (
    <main className="page">
      <SEO
        title="Om os"
        path="/om-os"
        description="Little-Stars er et familieunivers i Randers NV for gravide, babyer og børn 0–10 år. Læs om vores historie, værdier og find kontaktoplysninger."
      />

      <div className="page-hero">
        <div className="page-hero-bg" style={{ '--c1': '#F4A7C0', '--c2': '#B8A0D4' }} />
        <div className="page-hero-content">
          <div className="page-label">Om os</div>
          <h1>Mere end et <span className="gradient-text">legeland</span></h1>
          <p>Et familieunivers for gravide, babyer, børn og deres forældre.</p>
        </div>
      </div>

      <SectionWave color="#f7f8fc" />

      {/* OM LITTLE-STARS */}
      <section className="content-section bg-soft">
        <div className="container">
          <div className="om-os-layout">
            <div>
              <div className="section-label">Vores historie</div>
              <h2 className="section-title">Hvad er <span className="gradient-text">Little-Stars?</span></h2>
              <div className="om-os-text">
                <p>
                  Little-Stars er et familieunivers for gravide, babyer, børn og deres forældre.
                  Her samler vi alt fra legeområder, legeland, holdtræninger, events, foredrag og
                  det sociale, som ofte er en del af dagligdagen under graviditets-, barsels- og
                  hjemmepasser-tiden.
                </p>
                <p>
                  Alle er velkomne hos os - store som små. Du er meget velkommen til at besøge os,
                  selvom du ikke længere er gravid, på barsel, og dine børn er startet i institution,
                  eller du blot finder et af vores foredrag eller events attraktive. Her er plads til alle.
                </p>
                <p>
                  Vi henvender os primært til børn i alderen 0–6 år, men større børn er også velkomne
                  - hvis I blot husker at respektere de mindre børn.
                </p>
                <p>
                  Vi skaber et sted, hvor der er plads til grin, hygge og leg, men også til de lidt
                  dybere samtaler.
                </p>
              </div>
            </div>
            <div className="om-os-visual">
              <div className="visual-blob">
                <span>🌟</span>
                <div className="visual-text">
                  <strong>Randers NV</strong>
                  <span>CVR 45984052</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SectionWave color="#ffffff" />

      {/* VÆRDIER */}
      <section className="content-section bg-white">
        <div className="container">
          <div className="section-label" style={{ textAlign: 'center' }}>Vores værdier</div>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Det vi <span className="gradient-text">tror på</span></h2>
          <div className="vaerdier-grid">
            {vaerdier.map(v => (
              <div className="vaerdi-card" key={v.title}>
                <div className="vaerdi-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SectionWave color="#f7f8fc" />

      {/* KONTAKT */}
      <section className="content-section bg-soft">
        <div className="container">
          <div className="section-label">Kontakt</div>
          <h2 className="section-title">Kom i <span className="gradient-text">kontakt</span></h2>
          <div className="kontakt-grid">
            <div className="kontakt-card">
              <div className="kontakt-icon">📍</div>
              <h3>Adresse</h3>
              <p>Hovedvejen 8<br />8920 Randers NV</p>
            </div>
            <div className="kontakt-card">
              <div className="kontakt-icon">📧</div>
              <h3>E-mail</h3>
              <a href="mailto:info@little-stars.dk">info@little-stars.dk</a>
            </div>
            <div className="kontakt-card">
              <div className="kontakt-icon">📱</div>
              <h3>Instagram</h3>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Følg os på Instagram</a>
            </div>
            <div className="kontakt-card">
              <div className="kontakt-icon">🏢</div>
              <h3>CVR-nr.</h3>
              <p>45984052</p>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
